export enum LotteryDialogs {
  CLASSIC_LOTTERY = 'CLASSIC_LOTTERY',
  SINGLE_LOTTERY = 'SINGLE_LOTTERY',
  RULES = 'RULES',
}
